import { useCallback, useState } from 'react'
import { gql, useMutation } from '@apollo/client'
import validate from './validation'
export default (onSuccess, onError) => {
  const [mutation, { data, error, loading }] = useMutation(
    gql`mutation (
        $lessonInput: EditLessonInputFromAdmin!
        $lessonId: String!
        $noDateChanges: Boolean
    ) {
          editMeetingFromAdmin(
            lessonInput: $lessonInput
            lessonId: $lessonId
            noDateChanges: $noDateChanges
          ){
            success
            blocks
            studentTimeZone
            educatorTimeZone
            lesson
        }
    }`
  )
  const [validationErrors, setValidationErrors] = useState({})
  const submitRaw = useCallback(async (obj) => {
    const errors = validate(obj)
    if (errors && Object.keys(errors).length) {
      setValidationErrors(errors)
      throw new Error('validation Error')
    }
    try {
      return await mutation({ variables: obj })
    } catch (e) {
      setValidationErrors({ general: 'misc.apiError' })
      throw e
    }
  }, [mutation])
  const submit = useCallback((obj) => {
    submitRaw(obj).then((result) => {
      onSuccess(result)
    }).catch((e) => {
      onError(e)
    })
  }, [submitRaw, onSuccess, onError])
  return { loading, data: data ? data.editLessonFromAdmin : null, error, validationErrors, submit, submitRaw }
}
